import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { type FC } from 'react';

import { useEarlyAccessSelector } from '@/packages/redux-state/store/slices/earlyAccess';
import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { EarlyAccessBanner } from './components/EarlyAccessBanner';
import { useEarlyAccessListingUrl } from './hooks/useEarlyAccessListingUrl';
import { trackEarlyAccessBannerClick, trackEarlyAccessBannerShow } from './tracking';

export const EarlyAccessBannerContainer: FC = () => {
  const earlyAccessData = useEarlyAccessSelector();
  const viewMode = useListingLayoutViewModeSelector();
  const listingWithEarlyAccessOffersUrl = useEarlyAccessListingUrl();

  /* istanbul ignore next */
  if (!earlyAccessData || viewMode !== 'list') {
    return null;
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={trackEarlyAccessBannerShow}>
      <EarlyAccessBanner
        {...earlyAccessData}
        listingUrl={listingWithEarlyAccessOffersUrl}
        onLinkClick={trackEarlyAccessBannerClick}
      />
    </ActionAfterViewObserver>
  );
};
